import { TrazabilitySection } from './TrazabilitySection';

export type { TypeTrazabilitySectionProps } from './types';
export default TrazabilitySection;
